import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { getMediaList } from "services/apiService";
import { useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { toggleVideoSelection } from "../../../redux/Slice/mediaSlice.js";
import { Box, IconButton, Modal } from "@mui/material";

const VideoGallery = ({
  isOpen,
  onRequestClose,
  isMulti,
  keyName,
  handleBlur,
}) => {
  const dispatch = useDispatch();
  const AppUrl = process.env.REACT_APP_IMAGE_URL;
  const { data: video } = useQuery("video", getMediaList);

  const handleImageToggle = ({ keyName, mediaUrl, isMulti }) => {
    dispatch(toggleVideoSelection({ keyName, mediaUrl, isMulti }));
  };
  const multiVideo = useSelector(
    (state: any) => state.media.selectedVideosByKey
  );
  const singleVideo = useSelector(
    (state: any) => state.media.singleVideoSelections
  );
  const selectedVideos = multiVideo ? multiVideo[keyName] : undefined;
  const removeQuets = selectedVideos ? selectedVideos.split(",") : [];
  const singleSelect = singleVideo ? singleVideo[keyName] : "";
  const filteredFiles = removeQuets.filter((file) => file !== "");
  return (
    <Modal
      open={isOpen}
      onClose={onRequestClose}
      aria-labelledby="video-gallery"
    >
      <Box
        sx={{
          width: "90%",
          maxWidth: "1020px",
          maxHeight: "80vh",
          overflow: "auto",
          borderRadius: "10px",
          padding: "20px",
          position: "relative",
          margin: "auto",
          backgroundColor: "#fff",
          boxShadow: 24,
          p: 4,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col">
              <h2>Video Gallery</h2>
            </div>
            <div className="col-auto">
              <IconButton onClick={onRequestClose} sx={{ fontSize: "30px" }}>
                <FontAwesomeIcon icon={faTimes} style={{ color: "#63E6BE" }} />
              </IconButton>
            </div>
          </div>
          <div className="row">
            {video?.data
              ?.filter(
                (url) =>
                  url.endsWith(".mp4") ||
                  url.endsWith(".mov") ||
                  url.endsWith(".avi") ||
                  url.endsWith(".gif")
              )
              .map((mediaUrl, index) => (
                <div key={index} className="col-md-4 mb-4">
                  <div
                    style={{
                      width: "200px",
                      height: "auto",
                      border: "1px solid #ddd",
                      padding: "5px",
                      borderRadius: "5px",
                      position: "relative",
                    }}
                  >
                    <video
                      src={AppUrl + mediaUrl}
                      className="img-fluid"
                      controls
                    />
                    <input
                      name={keyName}
                      key={keyName}
                      type="checkbox"
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "5px",
                        zIndex: "10",
                      }}
                      checked={
                        isMulti
                          ? filteredFiles?.includes(mediaUrl)
                          : singleSelect === mediaUrl
                      }
                      onChange={(e) =>
                        handleImageToggle({ keyName, mediaUrl, isMulti })
                      }
                    />
                  </div>
                </div>
              ))}
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default VideoGallery;
